<template>
    <v-toolbar color="blue-grey darken-4" acolor="#2B3848" dark>
        <v-toolbar-title class="mr-4">{{ model }}</v-toolbar-title>
    </v-toolbar>
</template>

<style lang="scss" scoped>
</style>


<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {

    @Prop({ required: true })
    model?: string;

}
</script>
